import { useContext } from 'react';
import { assertNonNull } from '../queues/utils/assert-non-null';
import { WorkspacePanelsStoreContext } from './workspace-store-provider';
import { WorkspaceStore } from './workspace-store';

/**
 * Returns the nearest WorkspacePanelsStore instance from context
 */
export function useWorkspaceStore(): WorkspaceStore {
    const workspacePanelsStore = useContext(WorkspacePanelsStoreContext);
    assertNonNull(workspacePanelsStore, 'Unexpectedly did not find WorkspacePanelsStore');
    return workspacePanelsStore;
}
